module.exports = __webpack_public_path__ + "static/img/5-02.ac39420.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/newsDetail/5-02.png
// module id = hyqQ
// module chunks = 1